import { createSelector } from 'reselect';

const sgipBaseCalc = (state) => {
    const { esskW, esskWh } = state.ess;
    const { sgipValue } = state.sgip;

    const storageDurationRatio = esskWh / esskW;
    let sgipBase = 0;

    if (esskWh <= 2000000) {
        if (storageDurationRatio <= 2) {
            sgipBase = esskWh * sgipValue * 1000;
        } else if (storageDurationRatio > 2 && storageDurationRatio <= 4) {
            sgipBase =
                2 * esskW * sgipValue * 1000 +
                (storageDurationRatio - 2) * esskW * sgipValue * 1000 * 0.5;
        } else if (storageDurationRatio > 4 && storageDurationRatio <= 6) {
            sgipBase =
                2 * esskW * sgipValue * 1000 +
                2 * esskW * sgipValue * 1000 * 0.5 +
                (storageDurationRatio - 4) * esskW * sgipValue * 1000 * 0.25;
        } else if (storageDurationRatio > 6) {
            sgipBase =
                2 * esskW * sgipValue * 1000 +
                2 * esskW * sgipValue * 1000 * 0.5 +
                2 * esskW * sgipValue * 1000 * 0.25;
        }
    } else if (esskWh > 2000000 && esskWh <= 4000000) {
        if (storageDurationRatio <= 2) {
            sgipBase = esskWh * sgipValue * 1000 * 0.5 * 0.5;
        } else if (storageDurationRatio > 2 && storageDurationRatio <= 4) {
            sgipBase =
                (2 * esskW * sgipValue * 1000 +
                    (storageDurationRatio - 2) * esskW * sgipValue * 1000 * 0.5) *
                0.5;
        } else if (storageDurationRatio > 4 && storageDurationRatio <= 6) {
            sgipBase =
                (2 * esskW * sgipValue * 1000 +
                    2 * esskW * sgipValue * 1000 * 0.5 +
                    (storageDurationRatio - 4) * esskW * sgipValue * 1000 * 0.25) *
                0.5;
        } else if (storageDurationRatio > 6) {
            sgipBase =
                (2 * esskW * sgipValue * 1000 +
                    2 * esskW * sgipValue * 1000 * 0.5 +
                    2 * esskW * sgipValue * 1000 * 0.25) *
                0.5;
        }
    } else if (esskWh > 4000000 && esskWh <= 6000000) {
        if (storageDurationRatio <= 2) {
            sgipBase = esskWh * sgipValue * 1000 * 0.5 * 0.25;
        } else if (storageDurationRatio > 2 && storageDurationRatio <= 4) {
            sgipBase =
                (2 * esskW * sgipValue * 1000 +
                    (storageDurationRatio - 2) * esskW * sgipValue * 1000 * 0.25) *
                0.25;
        } else if (storageDurationRatio > 4 && storageDurationRatio <= 6) {
            sgipBase =
                (2 * esskW * sgipValue * 1000 +
                    2 * esskW * sgipValue * 1000 * 0.5 +
                    (storageDurationRatio - 4) * esskW * sgipValue * 1000 * 0.25) *
                0.25 *
                0.25;
        } else if (storageDurationRatio > 6) {
            sgipBase =
                (2 * esskW * sgipValue * 1000 +
                    2 * esskW * sgipValue * 1000 * 0.5 +
                    2 * esskW * sgipValue * 1000 * 0.25) *
                0.25 *
                0.25;
        }
    }

    return sgipBase;
};

export const sgipIncentiveValue = (state) => {
    const { madeInCA, esskW, includeESS } = state.ess;
    const { projectState } = state.projectaddress;

    let totalSGIP = 0;

    if (projectState === 1) {
        if (includeESS === false) {
            totalSGIP = 0;
        } else if (sgipBaseCalc(state) > 5000000) {
            totalSGIP = 5000000;
        } else {
            totalSGIP = sgipBaseCalc(state);
        }

        let sgipTotal = 0;
        if (madeInCA === true) {
            sgipTotal = 1.2 * totalSGIP;
        } else {
            sgipTotal = totalSGIP;
        }

        let sgip = 0;
        if (esskW >= 30) {
            sgip = sgipTotal / 2;
        } else {
            sgip = sgipTotal;
        }
        return sgip;
    }
    return totalSGIP;
};

export const selectSGIPIncentiveValue = createSelector(sgipIncentiveValue, sum => sum);



// WEBPACK FOOTER //
// ./src/containers/common/sgip/selectors.js